export const stringToColor = (str: string, seed: number) => {
  const usedHues = new Set();

  // return strings.map((str, index) => {
  // Create a hash value based on the string
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  // Ensure hue is distinct by spacing them out
  let hue = Math.abs(hash) % 360;

  // Prevent similar hues
  while (usedHues.has(hue)) {
    hue = (hue + 37) % 360; // jump by a prime number to avoid clustering
  }
  usedHues.add(hue);

  const saturation = 65 + ((seed * 7) % 20); // vary saturation a bit
  const lightness = 50 + ((seed * 11) % 10); // vary lightness slightly

  return hslToHex(hue, saturation, lightness);
  // });
};

// Helper: Convert HSL to HEX
function hslToHex(h: number, s: number, l: number) {
  s /= 100;
  l /= 100;

  const k = (n: number) => (n + h / 30) % 12;
  const a = s * Math.min(l, 1 - l);
  const f = (n: number) =>
    Math.round(
      255 * (l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)))),
    )
      .toString(16)
      .padStart(2, '0');

  return `#${f(0)}${f(8)}${f(4)}`;
}
